export default __webpack_public_path__ + "1d71f601f2bb65a9426f81672476fb3c.svg";